module.exports = __webpack_public_path__ + "img/41165799000153.39d8c2b8.png";